<template>
  <div
    v-if="isOpen"
    class="preview-popup"
  >
    <div class="popup">
      <div class="head">
        <span
          class="name"
          v-html="$t('affiliates.affiliatesOffers.view')"
        />
        <UiIcon
          :size="20"
          class="close"
          name="times"
          @click="close"
        />
      </div>
      <div
        class="popup-body"
      >
        <OfferInfo
          v-if="isOpen"
          :is-edit-offer="false"
          :is-diff="true"
          :is-delete-offer="false"
          :offer-info="getOfferInfo"
        />
      </div>
      <div
        class="foot"
      >
        <UiButton
          filled
          icon="check"
          @click="close"
        >
          {{ $t('crm.buttons.close') }}
        </UiButton>
      </div>
    </div>
    <div class="wrapper" />
  </div>
</template>

<script>
import OfferInfo from '@/components/OfferInfo.vue';
import offerMixin from '@/views/mixins/offer';

export default {
  name: 'PreviewPopup',
  components: {
    OfferInfo,
  },
  mixins: [offerMixin],
  props: {
    offerInfo: {
      type: Object,
      default() {
        return {};
      },
    },

    isOpen: {
      type: Boolean,
      required: true,
    },
    isDataLoading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {

    };
  },
  computed: {
    getOfferInfo() {
      const { payout_rules, ...restProps } = this.offerInfo;

      return {
        ...restProps,
        payout_rules: payout_rules?.map((rule) => ({
          ...rule,
          settings: {
            ...rule.settings,
            rev_share: rule.settings.rev_share ? {
              sport_levels: rule.settings.rev_share.sport_levels,
              casino_levels: this.$_.isEqual(rule.settings.rev_share.sport_levels, rule.settings.rev_share.casino_levels)
                ? null : rule.settings.rev_share.casino_levels,
            } : null,
            cpa: rule.settings.cpa?.map(this.genCpaParams) || null,
          },
        })) || null,
      };
    },
  },
  watch: {

  },

  async mounted() {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-popup {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;

  .wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background-color: #303634;
    z-index: 901;
  }

  .popup {
    position: relative;
    z-index: 902;
    height: auto;
    max-height: 95vh;
    width: 800px;
    border-radius: 8px;
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .head {
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eaeaea;
      .name {
        font-size: 20px;
        font-weight: 500;
      }
      .close {
        font-size: 15px;
        cursor: pointer;
        padding: 5px;
        &:hover{
          color: var(--text-primary) !important;
        }
      }
    }
    .popup-body{
      height: 580px;
      overflow-y: auto;
    }
    .foot {
      display: flex;
      border-top: 1px solid #eaeaea;
      padding: 16px 24px;
      justify-content: flex-end;
    }
  }
}

</style>
